// extracted by mini-css-extract-plugin
export var aircallIframe = "_dz-3";
export var fabContainer = "_dz-5";
export var fabRinging = "_dz-6";
export var loadingOverlay = "_dz-4";
export var pulse = "_dz-7";
export var widgetContent = "_dz-2";
export var widgetPanel = "_dz-0";
export var widgetPanelExpanded = "_dz-1";